<template>
  <div>
    <!-- 底部-->
    <div   :class="[IsKfcFoot ? 'kfc-color' : '','footer-wrap']">
      <div class="footer-box">
<!--        <div class="footer-tag">-->
<!--          <span>关于我们</span>-->
<!--          <span>法律声明</span>-->
<!--          <span>廉政举报</span>-->
<!--          <span>友情链接</span>-->
<!--        </div>-->
        <div class="copyright"><a href="https://beian.miit.gov.cn">闽ICP备18000338号-6</a></div>
        <div style="width:300px;margin:0 auto;">
          <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="@/assets/img/baLogo.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">闽公网安备 35021102001653号</p ></a >
        </div>
      </div>
    </div>
    <!-- 底部-->
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    IsKfcFoot: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  /* 底部*/
  .footer-wrap {
    background: #333333;
    height: 165px;
    text-align: center;
  }

  .footer-wrap .footer-box {
    padding: 50px 0;
    background: #333333;
    padding-bottom: 30px;
  }

  .footer-wrap .footer-box .footer-tag {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #ffffff;
  }

  .footer-wrap .footer-box .footer-tag span {
    margin: 0 20px;
  }

  .footer-wrap .footer-box .copyright {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #999999;
    line-height: 50px;
  }
  /* 底部*/
  .footer-wrap.kfc-color{
    background: #F5F5FA !important;
  }
  .kfc-color .footer-box .footer-tag {
    color: #666666 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue